<p-panel header="{{ 'fs.res.common.finance.researchContract.income' | hisUi }}">
    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>

    <div>
        <!-- no requiered research contract assigned -->
        <div *ngIf="!researchContracts || researchContracts.length === 0">
            <p>{{ infoAssignmentReceiptsLabel || (infoAssignmentReceipts | hisUi) }}</p>
        </div>
        <!-- no record found -->
        <div class="infoMessage" *ngIf="researchContracts?.length > 0 && researchContractIncomes?.length === 0">
            {{ 'fs.res.common.finance.researchContract.noIncomesAssigned' | hisUi }}
        </div>

        <button *ngIf="!disableInput && researchContracts?.length > 0" (click)="addResearchContractIncome()"
                hisImage="plus_circ_green" class="transparent">
            <span>{{ 'fs.res.common.finance.researchContract.assignIncomes' | hisUi }}</span></button>

        <p-table *ngIf="researchContractIncomes?.length > 0" [value]="researchContractIncomes" [paginator]="true"
                 [rows]="10"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [totalRecords]="researchContractIncomes.length" [rowsPerPageOptions]="researchContractIncomes.length > 10 ? rowsPerPageOptions : null">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngIf="rowColoring">
                        {{ 'fs.res.finance.researchContract.no' | hisUi }}
                    </th>
                    <th [pSortableColumn]="'budgetSourceName'">
                        {{ getDdLabeltextIdentifier('budgetSource.defaulttext') | hisUi }}
                        <p-sortIcon *ngIf="researchContractIncomes.length > 1" [field]="'budgetSourceName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'year'">
                        {{ getDdLabeltextIdentifier('year') | hisUi }}
                        <p-sortIcon *ngIf="researchContractIncomes.length > 1" [field]="'year'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'incomeAmount'">
                         {{ getDdLabeltextIdentifier('incomeAmount') | hisUi }}
                        <p-sortIcon *ngIf="researchContractIncomes.length > 1" [field]="'incomeAmount'"></p-sortIcon>
                    </th>
                    <th>{{ 'common.actions' | hisUi }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-researchContractIncome let-index="rowIndex" >
                <tr [ngClass]="rowColoring ? cssClassUtils.getRowColorCSSClass(indexInResearchContracts( researchContractIncome, researchContracts)) : ''">

                    <td *ngIf="rowColoring">
						<span
                            class="{{ cssClassUtils.getRowCharacterCSSClass(indexInResearchContracts( researchContractIncome, researchContracts)) }} badge_character">
							{{ indexInResearchContracts(researchContractIncome, researchContracts) + 1 }}
						</span>
                        <ng-container
                            *ngIf="researchContracts[indexInResearchContracts( researchContractIncome, researchContracts)] as _researchContract">
							<span *ngIf="_researchContract.budgetSource.organization">
								<img hisImage="HOUSE" class="inlineicon"
                                     [title]="'fs.res.finance.researchContract.budgetSource.orgunitObj.house' | hisUi">
							</span>
                        </ng-container>
                    </td>
                    <td>
                        {{ researchContractIncome.budgetSourceName ? researchContractIncome.budgetSourceName : '' }}
                    </td>
                    <td>
                        {{researchContractIncome.year}}
                    </td>
                    <td>
                        {{ amountUtils.getFormattedAmount(researchContractIncome.incomeAmount) }}
                    </td>
                    <td class="singleLine">
                        <button (click)="editResearchContractIncome(researchContractIncome, index)" hisImage="PENCIL"
                            class="icon" [title]="'fs.res.common.finance.researchContract.editIncomesOf'|hisUi:(researchContractIncome.budgetSourceName):(amountUtils.getFormattedAmount(researchContractIncome.incomeAmount))+' €':(researchContractIncome.year)" [disabled]="disableInput"></button>
                        <button (click)="deleteResearchContractIncome(researchContractIncome)" hisImage="DELETE"
                            class="icon" [title]="'fs.res.common.finance.researchContract.deleteIncomesOf'|hisUi:(researchContractIncome.budgetSourceName):(amountUtils.getFormattedAmount(researchContractIncome.incomeAmount))+' €':(researchContractIncome.year)" [disabled]="disableInput"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>

</p-panel>

<!-- create new research contract income in popup -->
<res-edit-research-contract-income-dialog *ngIf="researchContractIncomeVisibility" [(visibility)]="researchContractIncomeVisibility"
    [hisDdKeyPrefix]="hisDdKeyPrefix"
    [researchContracts]="researchContracts"
    [editIndex]="editIndexToRemember"
    [researchContractIncome]="researchContractIncome"
    (researchContractIncomeChange)="researchContractIncomeChange($event)">
</res-edit-research-contract-income-dialog>

